import { render, staticRenderFns } from "./Gemeinsames_Mittagessen.vue?vue&type=template&id=68c191b1&"
import script from "./Gemeinsames_Mittagessen.vue?vue&type=script&lang=js&"
export * from "./Gemeinsames_Mittagessen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports